export default class FeatureFlagService {
	ldClient = null;

	static setClient(ldclient) {
		this.ldClient = ldclient;
	}

	static isEnabled(featureFlagKey) {
		return this.ldClient.variation(featureFlagKey, false);
	}
}
